<div class="appContentsContainer">
  <form
    [formGroup]="requestCOC"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div class="pageTitle">Seleccione el tipo de solicitud</div>
    <div class="lineGradient"></div>
    <div class="wrapper">
      <div class="firstPart">
        <label for="Individual" id="Individual"> Individual </label>
      </div>
      <div class="secondPart">
        <span>
          <input
            id="certificateType"
            type="radio"
            value="individual"
            name="certificateType"
            style="cursor: pointer !important"
            (change)="changeCertificateType($event)"
            checked
          />
        </span>
        <div class="extraTextContainer">
          <div class="extraText">
            <em
              class="fas fa-info-circle"
              data-toggle="tooltip"
              data-placement="top"
              title="Un único bastidor"
            ></em>
          </div>
        </div>
      </div>
      <div class="firstPart">
        <label for="Masiva" id="Masiva"> Masiva </label>
      </div>
      <div class="secondPart">
        <span>
          <input
            id="certificateType"
            type="radio"
            value="masiva"
            name="certificateType"
            style="cursor: pointer !important"
            (change)="changeCertificateType($event)"
          />
        </span>
        <div class="extraTextContainer">
          <div class="extraText">
            <em
              class="fas fa-info-circle"
              data-toggle="tooltip"
              data-placement="top"
              title="Varios bastidores"
            ></em>
          </div>
        </div>
      </div>
      <div class="firstPart">
        <label for="Masiva" id="MasivaLeasing"> Masiva leasing </label>
      </div>
      <div class="secondPart">
        <span>
          <input
            id="certificateType"
            type="radio"
            value="leasing"
            name="certificateType"
            style="cursor: pointer !important"
            (change)="changeCertificateType($event)"
          />
        </span>
        <div class="extraTextContainer">
          <div class="extraText">
            <em
              class="fas fa-info-circle"
              data-toggle="tooltip"
              data-placement="top"
              title="Varios bastidores de leasing"
            ></em>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="requestType == 'individual'">
      <div class="pageTitle">Indique bastidor</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart">
          <label id="bastidor" for="bastidor"> Número de bastidor </label>
        </div>
        <div class="secondPart">
          <input
            class="inputSearch"
            type="text"
            formControlName="bastidor"
            toUppercase
          />
          <div class="supIndexRequest">*</div>
          <button
            class="searchButton"
            type="button"
            (click)="validateVehiculo()"
            *ngIf="!vehiculoValid"
          >
            <div class="iconSearch">
              <em
                class="fas fa-check-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Validar bastidor"
              ></em>
            </div>
          </button>
          <button
            class="searchButton"
            type="button"
            (click)="initFormIndividual()"
            *ngIf="vehiculoValid"
          >
            <div class="iconSearch">
              <em
                class="fas fa-sync-alt"
                data-toggle="tooltip"
                data-placement="top"
                title="Reiniciar validación"
              ></em>
            </div>
          </button>
        </div>

        <div class="firstPart">
          <label id="primerMatriculacion" for="primerMatriculacion">
            Primera matriculación
          </label>
        </div>

        <div class="secondPart">
          <input type="date" formControlName="primerMatriculacion" />
          <div class="supIndexRequest">*</div>
        </div>
      </div>

      <div class="pageTitle">Adjunte fichero</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart">
          <label id="otroDocumentoAdjuntar"> Documentación </label>
        </div>
        <div class="secondPart">
          <div
            class="dummyButtonContainerAux"
            style="cursor: pointer !important"
          >
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{ file.name }}
              </div>
            </div>
          </div>
          <input
            class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            id="documentacion"
            style="cursor: pointer !important"
            (change)="handleFileInput($event)"
          />
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="requestType == 'masiva' || requestType == 'leasing'">
      <div class="pageTitle">Excel con la lista de los bastidores</div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart">
          <label id="otroDocumentoAdjuntar"> Fichero excel </label>
        </div>
        <div class="secondPart">
          <div
            class="dummyButtonContainerAux"
            style="cursor: pointer !important"
          >
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{ excel.name }}
              </div>
            </div>
          </div>
          <input
            #excelInputFile
            class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            id="excel"
            style="cursor: pointer !important"
            (change)="handleFileInput($event)"
            accept=".xls, .xlsx"
          />
          <div class="supIndexRequest">*</div>
          <div class="extraTextContainer">
            <div class="extraText">
              <em
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Columna A: Bastidores.&#013;&#010;Columna B: Fechas primera matriculación (dd/mm/yyyy).&#013;&#010;Sin encabezados."
              ></em>
            </div>
          </div>
        </div>
        <div class="firstPart">
          <label for="numBastidores" id="numBastidores">
            Número de bastidores
          </label>
        </div>

        <div class="secondPart">
          <input
            type="number"
            formControlName="numBastidores"
            min="0"
            (change)="setNumber()"
          />
          <div class="supIndexRequest">*</div>
          <div class="extraTextContainer">
            <div class="extraText">
              <em
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-placement="top"
                title="Introduzca el número de bastidores que contendrá el fichero adjunto, &#013;&#010;este debe coincidir con el número de lineas del fichero."
              ></em>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="requestType == 'leasing'">
        <div class="wrapper" style="margin-top: 5px">
          <div class="firstPart">
            <label for="otroDocumentoAdjuntar" id="otroDocumentoAdjuntar">
              Fichero documentación
            </label>
          </div>
          <div class="secondPart">
            <div
              class="dummyButtonContainerAux"
              style="cursor: pointer !important"
            >
              <div class="dummyButton">
                <em class="fas fa-file-upload"></em>
              </div>
              <div
                class="dummyFileInputAux"
                style="min-height: 20px !important"
              >
                <div
                  class="dummyFileNameAux adjustText"
                  style="max-height: 20px !important"
                >
                  {{ file.name }}
                </div>
              </div>
            </div>
            <input
              class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
              type="file"
              id="fichero"
              style="cursor: pointer !important"
              (change)="handleFileInput($event)"
            />
            <div class="supIndexRequest">*</div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="requestType == 'masiva' || requestType == 'leasing'">
      <div class="pageTitle">Seleccione la marca de los bastidores</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label for="marca" id="marca"> Marca vehículos </label>
        </div>
        <div class="secondPart">
          <ng-container *ngIf="puedeElegirSeat()">
            <label class="mr-1">SEAT/CUPRA</label>
            <span>
              <input
                class="solamenteFacturar"
                type="radio"
                value="SEAT"
                formControlName="marca"
                style="cursor: pointer !important"
                [checked]="requestCOC.value.marca == 'SEAT'"
                (change)="changeBrand($event)"
              />
            </span>
          </ng-container>
          <ng-container *ngIf="puedeElegirVolkswagen()">
            <label class="mr-1 ml-2">VW/AUDI/SKODA</label>
            <span>
              <input
                type="radio"
                value="VOLKS"
                formControlName="marca"
                style="cursor: pointer !important"
                [checked]="requestCOC.value.marca == 'VOLKS'"
                (change)="changeBrand($event)"
              />
            </span>
          </ng-container>
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="pageTitle">
        Añada las observaciones que considere oportunas
      </div>
      <div class="lineGradient"></div>
      <div class="wrapper">
        <div class="firstPart">
          <label for="observacion" id="observacion"> Observaciones </label>
        </div>
        <div class="secondPart">
          <textarea
            type="textarea"
            formControlName="observacion"
            maxlength="650"
          ></textarea>
        </div>
      </div>
    </ng-container>

    <div class="blockOfTextLipsum">
      <p [innerHTML]="requestText"></p>
    </div>
    <div class="wrapper">
      <div class="firstPart" style="text-align: left; background-color: white">
        <button class="formButtonBack" type="button" (click)="goList()">
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="secondPart">
        <div>
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <swal
    #confirmSwal
    title=""
    text=""
    confirmButtonText="Crear una petición nueva"
    denyButtonText="Volver al buzón"
    icon="success"
    [showCancelButton]="false"
    [focusCancel]="true"
    [showDenyButton]="true"
    [swalOptions]="{
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
    (confirm)="createAnotherRequest()"
    (deny)="goList()"
  >
  </swal>
</div>
